import { useEffect, useState } from "react";

const OFFLINE_MODE_KEY = "planificador_offline_mode";

export function getOfflineMode() {
  return localStorage.getItem(OFFLINE_MODE_KEY) === "true";
}

export function setOfflineMode(value) {
  localStorage.setItem(OFFLINE_MODE_KEY, value ? "true" : "false");
  window.dispatchEvent(new Event("offline-mode-change"));
}

export function useOfflineMode() {
  const [offlineMode, setOfflineModeState] = useState(getOfflineMode());

  useEffect(() => {
    const handler = () => {
      setOfflineModeState(getOfflineMode());
    };

    window.addEventListener("offline-mode-change", handler);
    window.addEventListener("storage", handler);

    return () => {
      window.removeEventListener("offline-mode-change", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  const updateOfflineMode = (value) => {
    setOfflineMode(value);
    setOfflineModeState(value);
  };

  return [offlineMode, updateOfflineMode];
}
